import React from "react";
import {Dialog, DialogContent, DialogContentText, DialogTitle, useMediaQuery} from "@mui/material";
import { useTheme } from '@mui/material/styles';

const ThankYouPopup= () => {

    const theme = useTheme();
    const [open, setOpen] = React.useState(true);
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <>
            <Dialog  fullScreen={fullScreen} open={open} aria-labelledby="responsive-dialog-title">
                <div className={'dialogBorder'}>
            <DialogTitle id="responsive-dialog-title">{""}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Thank you for sharing your TERS payment information
                    with the UIF.
                </DialogContentText>
            </DialogContent>
                </div>
        </Dialog>
        </>
    );
}

export default ThankYouPopup;